import type { Plugin } from '@nuxt/types';

export default (({ app: { $analytics } }) => {
  window.onNuxtReady(() => {
    $analytics.logPageView();
  });
}) as Plugin;
